import * as React from 'react';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import styled from 'styled-components';
import { Button, MuiButtonProps } from '../Button/Button';
import Tooltip from '../Tooltip/Tooltip';
import { GroupButtonConfig } from './GroupButton';

interface Props<T extends string> extends Pick<MuiButtonProps, 'color' | 'size' | 'variant'> {
  buttonConfigs: GroupButtonConfig<T>[];
}

export function MuiButtonGroup<T extends string>({ buttonConfigs, color, size, variant }: Props<T>) {
  return (
    <ButtonGroup color={color} variant={variant} className="button_group" disableElevation data-test="button_group">
      {buttonConfigs.map((config) => (
        <StyledMuiButton
          $onlyIcon={!config.label}
          active={config.selected}
          key={config.id}
          startIcon={config.iconName}
          size={size}
          disabled={config.disabled}
          data-selected={config.selected ? 'true' : 'false'}
          dataTest={`group__button__${config.id}`}
          style={{ pointerEvents: !!config.disabled && !!config.tooltip ? 'auto' : undefined }}
          onClick={(event) => config.callback(config.id, event)}
        >
          <Tooltip title={config.tooltip ?? ''} key={config.id}>
            <span>
              <StyledWrapper />
              {config.label}
            </span>
          </Tooltip>
        </StyledMuiButton>
      ))}
    </ButtonGroup>
  );
}

export default MuiButtonGroup;

const StyledWrapper = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
`;

const StyledMuiButton = styled(Button)<{ $onlyIcon?: boolean }>`
  position: relative;
  .MuiButton-startIcon {
    ${({ $onlyIcon }) => ($onlyIcon ? `margin: 0` : ``)}
  }
`;
